	function k_get_Stock(data, variantName) {
	    var reg = new RegExp('(^|&)' + variantName + '=([^&]*)(&|$)', 'i');
	    var r = window.location.search.substr(1).match(reg);
	    if(r != null) {
	        var variantValue = unescape(r[2]);
	        return data[variantValue];
	    }
	    return null;
	}



	function k_get_ids(product_sku_id ,variantName='variant') {
	    var reg = new RegExp('(^|&)' + variantName + '=([^&]*)(&|$)', 'i');
	    var r = window.location.search.substr(1).match(reg);
	    if(r != null) {
	        var variantValue = unescape(r[2]);
	        return Number(variantValue);
	    }
	    return Number(product_sku_id);
	}



	//触发事件函数
	function k_click(selector, callback) {
		document.querySelectorAll(selector).forEach((element) => {
			element.addEventListener('click', callback);
		});
	}

	//写入到html 
	function k_set_text(selector, html,color=null) {
         if(color == null){
              document.getElementById(selector).innerHTML =  html;
         }else{
              document.getElementById(selector).innerHTML = '<span style="'+color+'">'+ html +'</span>';
         }
	}

	//写入到html 
	function k_set_style(selector, color=null) {
        // 获取元素
        var stockIco = document.getElementById(selector);
        stockIco.style.cssText =color;
	}



	function get_k_data(id, attribute,th=null) {
        var elem = document.getElementById(id);
        var data = elem ? elem.getAttribute(attribute) : '';
         if(th == null){
           return data;
         }else{
           return data.replace("X",th);
         }
    }

function k_time(num) {

  let currentDate = new Date();
  
  if (num) {
    num = Number(num);
    currentDate.setDate(currentDate.getDate() + num);
  }

  let monthNames = ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.",
    "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."
  ];

  let day = currentDate.getDate();
  let month = monthNames[currentDate.getMonth()];

  function getOrdinalSuffix(n) {
    if (n % 10 === 1 && n !== 11) {
      return n + "st";
    } else if (n % 10 === 2 && n !== 12) {
      return n + "nd";
    } else if (n % 10 === 3 && n !== 13) {
      return n + "rd";
    } else {
      return n + "th";
    }
  }

  return month + " " + getOrdinalSuffix(day);
}

function k_time_c(num) {

  let currentDate = new Date();
  
  if (num) {
    num = Number(num);
    currentDate.setDate(currentDate.getDate() + num + 5);
  }

  let monthNames = ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.",
    "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."
  ];

  let day = currentDate.getDate();
  let month = monthNames[currentDate.getMonth()];

  function getOrdinalSuffix(n) {
    if (n % 10 === 1 && n !== 11) {
      return n + "st";
    } else if (n % 10 === 2 && n !== 12) {
      return n + "nd";
    } else if (n % 10 === 3 && n !== 13) {
      return n + "rd";
    } else {
      return n + "th";
    }
  }

  return month + " " + getOrdinalSuffix(day);
}

function k_time_3(num) {

  let currentDate = new Date();
  
  if (num) {
    num = Number(num);
    currentDate.setDate(currentDate.getDate() + num -3);
  }

  let monthNames = ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.",
    "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."
  ];

  let day = currentDate.getDate();
  let month = monthNames[currentDate.getMonth()];

  function getOrdinalSuffix(n) {
    if (n % 10 === 1 && n !== 11) {
      return n + "st";
    } else if (n % 10 === 2 && n !== 12) {
      return n + "nd";
    } else if (n % 10 === 3 && n !== 13) {
      return n + "rd";
    } else {
      return n + "th";
    }
  }

  return month + " " + getOrdinalSuffix(day);
}

function k_time_c3(num) {

  let currentDate = new Date();
  
  if (num) {
    num = Number(num);
    currentDate.setDate(currentDate.getDate() + num + 2);
  }

  let monthNames = ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.",
    "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."
  ];

  let day = currentDate.getDate();
  let month = monthNames[currentDate.getMonth()];

  function getOrdinalSuffix(n) {
    if (n % 10 === 1 && n !== 11) {
      return n + "st";
    } else if (n % 10 === 2 && n !== 12) {
      return n + "nd";
    } else if (n % 10 === 3 && n !== 13) {
      return n + "rd";
    } else {
      return n + "th";
    }
  }

  return month + " " + getOrdinalSuffix(day);
}